import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Conditions, ConditionsList, WebserviceResponse} from "../interfaces";
import { catchError, retry } from 'rxjs/operators';
import { AlertService, IAlertType } from "./alert.service";
import { restBaseUrl } from "../utils/rest-url";

@Injectable({
  providedIn: 'root'
})
export class ConditionStoreService {
  private readonly endpoint = restBaseUrl('/conditions');

  constructor(
      private http: HttpClient,
      private alertDispatcher: AlertService) { }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Server-side error code: ${error.status} - message: ${error.message}`;
    }
    // window.alert(errorMessage);

    this.alertDispatcher.show({
      message: errorMessage,
      clrAlertType: IAlertType.DANGER
    }, 5000);

    // return throwError(errorMessage); deprecated
    return throwError(() => new Error(errorMessage));
  }

  public getConditionById(conditionId: number, conditionType: number): Observable<WebserviceResponse<Conditions[]>> {
    const options = new HttpParams({
      fromObject: {
        cond_id: conditionId,
        cond_type: conditionType
      }
    });
    return this.http.get<WebserviceResponse<Conditions[]>>(this.endpoint + '/get_conditions',
        { params: options }).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public getConditionByType(conditionType: number): Observable<WebserviceResponse<Conditions[]>> {
    const options = new HttpParams({
      fromObject: {
        cond_id: 0,
        cond_type: conditionType
      }
    });
    return this.http.get<WebserviceResponse<Conditions[]>>(this.endpoint + '/get_conditions',
        { params: options }).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public addCondition(condition: ConditionsList) {
    return this.http.post(
        `${this.endpoint}/add_condition`,
        condition,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public deleteCondition(conditionId: number) {
    return this.http.delete(
        `${this.endpoint}/delete_condition?condition_id=${conditionId}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateCondition(condition: ConditionsList): Observable<WebserviceResponse<Conditions[]>> {
    return this.http.put<WebserviceResponse<Conditions[]>>(
        `${this.endpoint}/update_condition`,
        condition,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }
}
